<template>
  <div class="body">
    <el-card>
      <el-form ref="form" :model="form" label-width="80px" @submit.native.prevent class="operationControl">
        <el-row>
          <el-col :span="5" class="pr20">
            <el-form-item label="教师姓名" prop="trainingName">
              <el-input v-model="form.name" @keyup.enter.native="search"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="pr20" style="margin-left: 30px">
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="$router.push(`/trainingManagement/addTeacher?type=add`)"
            >新增</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table  :data="teacherList" style="width: 100%" v-loading="tableLoading" element-loading-text="拼命加载中" height="640">
        <el-table-column type="index" width="60" label="序号"></el-table-column>
        <el-table-column prop="name" label="名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="phone" label="电话" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="professionalWorkingYears" label="工作年限（年）" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="lable" label="擅长领域" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="jobType" label="工作类型" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.jobType == 1">
              全职
            </span>
            <span v-else>
              兼职
            </span>
          </template>
        </el-table-column>

        <!--        <el-table-column label="图片">-->
<!--          <template slot-scope="scope">-->
<!--            <el-image-->
<!--              style="width: 100px; height: 100px"-->
<!--              :src="scope.row.pictureUrl"-->
<!--              :fit="fit"></el-image>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="createdTime" label="创建时间"></el-table-column>
        <el-table-column fixed="right" label="操作" width="400">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="
                $router.push(
                  '/trainingManagement/detailTeacher?type=check&id=' + scope.row.id
                )
              "
            >查看
            </el-button>
            <el-button
              size="mini"
              type="text"
              @click="
                $router.push(
                  '/trainingManagement/updateTeacher?type=edit&id=' + scope.row.id
                )
              "
            >编辑
            </el-button>
            <el-button
              size="mini"
              type="text"
              @click="delTercher(scope.row.id)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top:20px; float:right;"
        @size-change="sizeChange"
        :current-page="page"
        @current-change="pageChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import API from "../../api/new/training.js";

export default {
  data() {
    return {
      form: {
        trainingName: undefined, //培训内容
        principalName: undefined, //负责人名称
        trainingContent: undefined, //培训内容
        startCreatedTime: undefined, //制定开始时间
        endCreatedTime: undefined, //制定结束时间
        issuedStatus: undefined, //下发状态
        startIssuedTime: undefined, //下发开始时间
        endIssuedTime: undefined, //下发结束时间
        createdTime: [],
        issuedTime: []
      },
      teacherList: [],

      page: 1,
      pageSize: 10,
      total: 0, // 总条数

      tableLoading: true
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    pageChange(e) {
      this.page = e;
      this.getTercherList();
    },
    sizeChange(e){
      this.pageSize = e;
      this.getTercherList();
    },
    search(){
      this.page = 1;
      this.getTercherList();
    },
    getTercherList() {
      let p = {...this.form, enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId,};
      p.page = this.page;
      p.pageSize = this.pageSize;

      this.tableLoading  =  true;
      API.getTeacherList(p).then(res => {
        this.teacherList = res.data.records;
        this.total = res.data.total;
        this.tableLoading =  false;
      });
    },
    onSubmit() {
      console.log("submit!");
    },
    handleClick(row) {
      console.log(row);
    },
    //重置表单
    resetForm(formName) {
      this.form = {
        name: undefined
      }
      this.search();
    },
    delTercher(id) {
      this.$confirm("此操作将删除该计划, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        API.deleteTeacher({id: id}).then(res => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getTercherList();
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.form {
  position: relative;
}

.searchBut {
  position: absolute;
  right: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/teacherManagement.vue